import * as React from "react";
import PropTypes from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";
import UIButton from "../ui-controls/button";
import GetIcon from "../font-awesome-icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { useTheme } from "@mui/material/styles";
import CircularLoader from "../circular-loader";

const UIModal = ({
  open,
  onCancel,
  onClose,
  customFooterButtons = undefined,
  title = "Modal Title",
  children,
  size = "md",
  saveButtonTitle = "Update",
  cancelButtonTitle = "Cancel",
  saveCallback = () => console.log("save clicked"),
  saveBtnLoading,
  saveBtnHidden = false,
  cancelBtnHidden = false,
  saveBtnDisabled = false,
  saveBtnStyles = {},
  cancelBtnStyles = {},
  modalFooterSx = {},
  customFooterSx = {},
  modalSx = {},
  modalClasses = "",
  onEnter,
  onExit,
  disableEscapeKeyDown,
  showFooter = true,
  footerLoading = false,
  showFooterDivider = true,
  cancelButtonLoading = false,
}) => {
  const { palette } = useTheme();
  const handleClose = (e, reason) => {
    onClose(e, reason);
  };
  return (
    <Dialog
      fullWidth
      maxWidth={size}
      onClose={handleClose}
      open={open}
      className={modalClasses}
      disableScrollLock={true}
      sx={{
        "& .MuiDialog-paper": {
          overflowX: "hidden",
        },
        ...modalSx,
      }}
      onTransitionEnter={onEnter}
      onTransitionExited={onExit}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      {children}
      {showFooter && (
        <>
          {showFooterDivider && <Divider />}
          <DialogActions sx={{ padding: "10px 16px", ...modalFooterSx }}>
            <Box
              className="d-flex  w-100"
              sx={{
                gap: "10px",
                justifyContent: "flex-end",
                ...customFooterSx,
              }}
            >
              {footerLoading ? (
                <CircularLoader
                  sx={{ height: "auto", width: "auto" }}
                  iconSize="16px"
                />
              ) : null}
              {customFooterButtons ?? (
                <>
                  {!cancelBtnHidden && (
                    <UIButton
                      key={2}
                      title={cancelButtonTitle}
                      onClick={onCancel || onClose}
                      variant={"outlined"}
                      sx={{
                        // background: "var(--base-40)",
                        height: "38px",
                        ...cancelBtnStyles,
                      }}
                      loading={cancelButtonLoading}
                    />
                  )}
                  {!saveBtnHidden && (
                    <UIButton
                      key={3}
                      onClick={saveCallback}
                      title={saveButtonTitle}
                      loading={saveBtnLoading}
                      disabled={saveBtnDisabled || saveBtnLoading}
                      sx={{ height: "38px", ...saveBtnStyles }}
                    />
                  )}
                </>
              )}
            </Box>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
export default UIModal;

UIModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export const ModalTitle = ({
  children,
  handleClose,
  whiteHeader = false,
  hideCloseIcon = false,
  titleStyles = {},
}) => {
  const { palette } = useTheme();

  return (
    <DialogTitle
      sx={{
        minHeight: "80px",
        display: "flex",
        pr: 2,
        pl: 3,
        justifyContent: "space-between",
        ...titleStyles,
        ...(whiteHeader
          ? {
              borderBottom: "1px solid var(--palette-stroke)",
              minHeight: "auto",
            }
          : {
              // color: palette.primary.contrastText,
              color: palette.custom.header_text,
              // background: palette.primary.main,
              background: palette.custom.header_bg,
            }),
        alignItems: "center",
      }}
    >
      <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
        {children}
      </Box>
      {!hideCloseIcon && (
        <Box
          component="span"
          onClick={handleClose}
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <GetIcon
            icon={faXmark}
            iconStyles={{ fontSize: "1.5rem", cursor: "pointer" }}
          />
        </Box>
      )}
    </DialogTitle>
  );
};
export const ModalContent = ({ children, style = {} }) => {
  return <DialogContent style={style}>{children}</DialogContent>;
};
